/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { ServerResponseModel } from 'app/shared/models/serverResponse.model';

@Injectable({ providedIn: 'root' })
export class EmailsService {
  constructor(private httpClient: HttpClient) {}

  sendVerifyEmail(payload: any): Observable<any> {
    return this.httpClient
      .post(`${environment.apiHostname}/v1/emails/send-mail/${payload.id}/verify-registered-email`, {})
      .pipe(map(this.handleServerResponse));
  }

  sendReceiptEmail(payload: any): Observable<any> {
    return this.httpClient
      .post(`${environment.apiHostname}/v1/emails/receipt`, { data: payload })
      .pipe(map(this.handleServerResponse));
  }

  /**
   * Sends email validation confirmation
   *
   * @returns {Observable<number>}
   */
  confirmValidation(payload: any): Observable<any> {
    return this.httpClient
      .post(`${environment.apiHostname}/v1/emails/send-mail/${payload.id}/confirm-updated-email`, {})
      .pipe(
        map((response: any) => {
          if (response.result.success) {
            return response.data;
          } else {
            throw new Error('Error sending confirmation email');
          }
        })
      );
  }

  /**
   * Sends the confirm mail to the user after changing succesffully the password
   *
   * @returns {Observable<number>}
   */
  sendEmailPasswordChangeConfirmation(userId: number) {
    return this.httpClient.post(`${environment.apiHostname}/v1/emails/email-password-confirmation/${userId}`, {}).pipe(
      map((response: any) => {
        return response.result.success;
      })
    );
  }

  /**
   * Sends the confirm email to the user after requesting  highlight request reels
   *
   * @returns {Observable<any>}
   */
  sendHighlightRequestReelReceivedConfirmation(businessDays) {
    return this.httpClient
      .get(`${environment.apiHostname}/v1/emails/email/hrr-received/`, { params: { businessDays } })
      .pipe(map(this.handleServerResponse));
  }

  /**
   * Sends the confirm email to the user after submitting the pro feedback form
   *
   * @returns {Observable<any>}
   */
  sendProFeedbackReceivedConfirmation(purchaseId: number) {
    return this.httpClient
      .get(`${environment.apiHostname}/v1/emails/email/pro-feedback-received/${purchaseId}`)
      .pipe(map(this.handleServerResponse));
  }

  sendOrderRelatedEmails(orderId: any): Observable<any> {
    return this.httpClient
      .get(`${environment.apiHostname}/v1/emails/order-related/${orderId}`)
      .pipe(map(this.handleServerResponse));
  }

  private handleServerResponse = (response: ServerResponseModel) => {
    if (response.result.success) {
      return response.data;
    } else {
      throw new Error(response.result.message);
    }
  };
}
